import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import { GqlError, WithdrawWorksheetDocument } from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

import { Worksheet } from '../../types'

const withdrawWorksheet = async ({
  worksheetUid,
  reason,
}: {
  worksheetUid: Worksheet['uid']
  reason: string
}): Promise<void> => {
  try {
    await graphqlRequest(WithdrawWorksheetDocument, {
      worksheetUid,
      reason,
    })
  } catch (error) {
    throw error
  }
}

export const useWithdrawWorksheet = (
  options?: UseMutationOption<void, GqlError>,
) => {
  return useMutation(
    ({
      worksheetUid,
      reason,
    }: {
      worksheetUid: Worksheet['uid']
      reason: string
    }) => withdrawWorksheet({ worksheetUid, reason }),
    options,
  )
}
